import { ViewModelFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import { CalendarState } from '../../controller';
import { CalendarContext } from '../../../../utils/context/contextFactory';
import {
  BookingDetailsViewModel,
  getVideoConferencingBadge,
} from './bookingDetailsViewModel';
import { CalendarErrors, Preference } from '../../../../types/types';
import { isLightBox } from '@wix/bookings-catalog-calendar-viewer-utils';

export function createDummyBookingDetailsViewModel({
  context,
}: ViewModelFactoryParams<
  CalendarState,
  CalendarContext
>): BookingDetailsViewModel {
  const { t, settings, getContent, settingsParams, flowAPI } = context;

  const preferences = {
    bookingPreferences: [
      {
        error: {
          key: CalendarErrors.NO_SELECTED_LOCATION_ERROR,
          message: '',
        },
        key: Preference.LOCATION,
        placeholder: '',
        options: [
          {
            value: t('dummy-content.service.location'),
          },
        ],
      },
      {
        error: {
          key: CalendarErrors.NO_SELECTED_STAFF_MEMBER_ERROR,
          message: '',
        },
        key: Preference.STAFF_MEMBER,
        placeholder: '',
        options: [
          {
            value: getContent({
              settingsParam: settingsParams.staffMemberLabel,
              translationKey: 'dummy-content.service.staff',
            }),
          },
        ],
      },
      {
        error: {
          key: CalendarErrors.NO_SELECTED_DURATION_ERROR,
          message: '',
        },
        key: Preference.DURATION,
        placeholder: '',
        options: [
          {
            value: getContent({
              settingsParam: settingsParams.durationLabel,
              translationKey: 'dummy-content.service.duration',
            }),
          },
        ],
      },
    ],
    clearText: settings.get(settingsParams.bookingDetailsClearText),
    titleText: getContent({
      settingsParam: settingsParams.preferencesTitle,
      translationKey: 'app.settings.defaults.booking-details.preferences.title',
    }),
    appendToViewPort: !isLightBox(flowAPI.controllerConfig.wixCodeApi),
  };

  const calendarSummary = {
    serviceName: t('dummy-content.service.name'),
    selectedSlotDetails: {
      paymentDescription: t('dummy-content.service.price'),
      videoConferenceBadgeText: getVideoConferencingBadge(context),
      locationLabel: getContent({
        settingsParam: settingsParams.locationLabel,
        translationKey: 'dummy-content.service.location',
      }),
      staffMemberLabel: getContent({
        settingsParam: settingsParams.staffMemberLabel,
        translationKey: 'dummy-content.service.staff',
      }),
      durationLabel: getContent({
        settingsParam: settingsParams.durationLabel,
        translationKey: 'dummy-content.service.duration',
      }),
    },
  };

  return {
    preferences,
    calendarSummary,
  };
}
